import {createAction} from 'Shared/utilities/actionCreator';
import {AvailableAgentNumber} from 'Users/components/UserAdministration/UserEntry/AgentNumberInput';

export enum AgentNumberActionType {
  FETCH_AGENT_NUMBERS_BY_TAX_IDENTIFIER = 'agentnumber/FETCH_AGENT_NUMBERS_BY_TAX_IDENTIFIER',
  CHANGE_AGENT_NUMBERS = 'agentnumber/CHANGE_AGENT_NUMBERS',
}

export const fetchAgentNumbersByTaxIdentifier = (
  taxIdentifier: string,
  uniqueKey: string,
  encryptedIdentifier?: string
) =>
  createAction(AgentNumberActionType.FETCH_AGENT_NUMBERS_BY_TAX_IDENTIFIER, {
    taxIdentifier,
    uniqueKey,
    encryptedIdentifier,
  });
export const changeAgentNumbers = (agentNumbers: AvailableAgentNumber[], uniqueKey: string) =>
  createAction(AgentNumberActionType.CHANGE_AGENT_NUMBERS, {agentNumbers, uniqueKey});

type AgentNumbersDict = {
  [uniqueKey: string]: AvailableAgentNumber[];
};

type AgentNumberState = {
  agentNumbersDict: AgentNumbersDict;
};

export const DEFAULT_STATE: AgentNumberState = {
  agentNumbersDict: {},
};

type AgentNumberAction = ReturnType<typeof changeAgentNumbers>;

export default (state: AgentNumberState = DEFAULT_STATE, action: AgentNumberAction): AgentNumberState => {
  switch (action.type) {
    case AgentNumberActionType.CHANGE_AGENT_NUMBERS:
      return {
        ...state,
        agentNumbersDict: {...state.agentNumbersDict, [action.payload.uniqueKey]: action.payload.agentNumbers},
      };
    default:
      return state;
  }
};
